import { flex, IconFont, singleTextEllipsis } from '@byecode/ui'
import type { ButtonBlockTriggerEvent, ButtonSizeType } from '@lighthouse/core'
import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { buttonSizeMap } from './constant'

const btnHoverTransition = (): FlattenSimpleInterpolation => css`
    position: relative;
    &:hover::backdrop {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        /* cursor: not-allowed; */
        z-index: 0;
    }
`

const btnClickTransition = (): FlattenSimpleInterpolation => css`
    position: relative;
    &:active::before {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        /* cursor: not-allowed; */
        z-index: 0;
    }
`

const btnDisabled = (): FlattenSimpleInterpolation => css`
    position: relative;
    cursor: not-allowed;
    &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
        /* cursor: not-allowed; */
        border-radius: 6px;
        z-index: 1;
    }
`

export const Container = styled.button<{
    triggerEvents?: ButtonBlockTriggerEvent[]
    size: ButtonSizeType
    radius: string
    disabled?: boolean
}>`
    /* margin: 4px; */
    overflow: hidden;
    /* border-radius: 6px; */
    height: ${({ size }) => `${buttonSizeMap.get(size)}px`};
    border-radius: ${({ radius }) => radius};
    &:disabled {
        ${btnDisabled}
    }

    ${({ triggerEvents, disabled }) => triggerEvents?.includes('hover') && !disabled && btnHoverTransition}
    ${({ triggerEvents, disabled }) => triggerEvents?.includes('click') && !disabled && btnClickTransition}
`

export const Text = styled.div.withConfig<{ size?: number }>({ shouldForwardProp: p => p !== 'size' })`
    position: relative;
    z-index: 0;
    font-size: ${({ size }) => size ?? 14}px;
    white-space: nowrap;
    ${singleTextEllipsis}
`

export const Icon = styled(IconFont)<{ loading?: boolean; order: number }>`
    animation: ${({ loading }) => loading && ' loading-circle 1s linear infinite;'};
    order: ${({ order }) => order};
    z-index: 0;
    @keyframes loading-circle {
        0% {
            transform: rotate(0deg);
        }

        50% {
            transform: rotate(180deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
`

export const Wrapper = styled.div<{ event?: ButtonBlockTriggerEvent }>`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px 16px;
    ${flex}
    flex-direction: row;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    gap: 4px;
`
